export default {"src":"/_next/static/media/canyoning.63edfb78.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};